<template>
	<div
		data-element="checkout-btn-container"
		:data-size="containerSize"
	>
		<router-link
			v-background-color="$store.getters['ui/getSecondaryColor']"
			data-component="btn"
			v-if="href"
			:href="href"
			:data-size="size"
			:class="{ inactive: inactive}">
			<div data-element="quantity-container">
				<icon
					v-if="!inactive"
					icon="basket"
					:class="{ jiggle: animateBasket }"
					size="sm"
					data-element="icon"
					data-position="left"
					alt="Basket"
				/>
				<span
					v-if="!inactive"
					data-element="quantity"
					v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
					v-modify-leading="{modifyLeading: $store.getters['ui/getBodyCopyFontLeading']}"
				>
					{{ basketCount }}
				</span>
			</div>
			<span
				data-element="text"
				v-if="!loading"
				v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
				v-modify-leading="{modifyLeading: $store.getters['ui/getBodyCopyFontLeading']}"
			>
				{{ text }}
			</span>
			<generic-loader v-else />
			<div
				data-element="price-container"
				v-if="!inactive"
			>
				<span
					data-element="price"
					v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
					v-modify-leading="{modifyLeading: $store.getters['ui/getBodyCopyFontLeading']}"
				>
					£{{ basketTotal }}
				</span>
			</div>
		</router-link>
		<button
			v-else
			v-background-color="$store.getters['ui/getSecondaryColor']"
			data-component="btn"
			@click="handleClick"
			:class="{ inactive: inactive}"
			tabindex="0"
		>
			<div data-element="quantity-container">
				<icon
					v-if="!inactive"
					icon="basket"
					:class="{ jiggle: animateBasket }"
					size="sm"
					data-element="icon"
					data-position="left"
					alt="Basket"
				/>
				<span
					v-if="!inactive"
					data-element="quantity"
					v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
					v-modify-leading="{modifyLeading: $store.getters['ui/getBodyCopyFontLeading']}"
				>
					{{ basketCount }}
				</span>
			</div>
			<span
				data-element="text"
				v-if="!loading"
				v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
				v-modify-leading="{modifyLeading: $store.getters['ui/getBodyCopyFontLeading']}"
			>
				{{ text }}
			</span>
			<generic-loader v-else />
			<div
				data-element="price-container"
				v-if="!inactive"
			>
				<span
					data-element="price"
					v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
					v-modify-leading="{modifyLeading: $store.getters['ui/getBodyCopyFontLeading']}"
				>
					£{{ basketTotal }}
				</span>
			</div>
		</button>
	</div>
</template>

<script>

	import Icon from '@/components/ui/Icon';
	import GenericLoader from '@/components/ui/GenericLoader';

	export default {
		data () {
			return {
				animateBasket: false
			}
		},
		props: [
			'href',
			'size',
			'text',
			'inactive',
			'basketTotal',
			'basketCount',
			'containerSize',
			'handleClick',
			'loading'
		],
		components: {
			Icon,
			GenericLoader
		},
		watch: {
			basketCount() {
				this.animateBasket = true;
				setTimeout(() => {
					this.animateBasket = false;
				}, 500);
			}
		}
	}
</script>

<style lang="scss">

	@import '@/assets/scss/variables.scss';
	@import '@/assets/scss/helpers.scss';

	[data-element='checkout-btn-container'] {
		position:relative;
		display:flex;
		align-items:center;
		justify-content:center;
		width:100%;
		max-width:456px;
		background-color:$white;
		cursor:pointer;
		-webkit-tap-highlight-color:transparent;
		&[data-size='md'] {
			padding:8px 16px;
		}
		@include whenScreenIs(sm) {
			display:flex;
			justify-content:center;
		}
			[data-component='btn'] {
				position:relative;
				width:100%;
				display:flex;
				align-items:center;
				justify-content:center;
				height:48px; width:100%;
				color:#ffffff;
				background:$jungle-green;
				border:none;
				-webkit-tap-highlight-color:transparent;
				&[data-size='md'] {
					width:calc(100% - 32px);
					margin:0 16px;
					@include whenScreenIs(sm) {
						width:208px;
					}
				}
				&[data-size='sm'] {
					height:50px; width:72px;
					@include whenScreenIs(sm) {
						height:48px;
					}
				}
				&.inactive {
					opacity:0.3;
					pointer-events:none;
				}
				&:focus {
					border:1px solid #fff;
					outline:none;
				}
				[data-element='quantity-container'] {
					position:absolute;
					left:10px;
					display:flex;
					align-items:center;
					height:100%;
					[data-element='icon']{
						margin-right:4px;
					}
					[data-element='quantity']{
						font-size:18px;
						font-weight:500;
					}
				}
				[data-element='text']{
					text-align:center;
					line-height:1.33;
					font-size:20px;
					font-weight:bold;
				}
				[data-element='price-container'] {
					position:absolute;
					right:10px;
					display:flex;
					align-items:center;
					justify-content:center;
					height:100%;
					[data-element='price'] {
						font-size:18px;
						font-weight:500;
					}
				}
				&:hover {
					background-color:$emerald;
					cursor:pointer;
				}
				&:active {
					opacity:0.85;
				}
		}
	}


</style>
